import * as Types from '../doorhub-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchItemGroupsQueryVariables = Types.Exact<{
  opt?: Types.InputMaybe<Types.SearchItemGroupsOptions>;
}>;


export type SearchItemGroupsQuery = { __typename?: 'Query', itemGroups: { __typename?: 'ItemGroupsConnection', itemGroups: Array<{ __typename?: 'ItemGroup', id: string, name: string, lockersystemId: string, maxRentingsPerUser?: number | null, maxRentingsPerUserEnabled: boolean, borrowingRightsUserGroups: Array<{ __typename?: 'UserGroup', id: string, name: string }> }> } };

export type ItemGroupQueryVariables = Types.Exact<{
  itemGroupId: Types.Scalars['ID'];
}>;


export type ItemGroupQuery = { __typename?: 'Query', itemGroup?: { __typename?: 'ItemGroup', id: string, name: string, lockersystemId: string, maxRentingsPerUser?: number | null, maxRentingsPerUserEnabled: boolean, borrowingRightsUserGroups: Array<{ __typename?: 'UserGroup', id: string, name: string }> } | null };

export type CreateItemGroupMutationVariables = Types.Exact<{
  input: Types.CreateItemGroup;
}>;


export type CreateItemGroupMutation = { __typename?: 'Mutation', createItemGroup: { __typename?: 'CreateItemGroupResponse', itemGroup?: { __typename?: 'ItemGroup', id: string, name: string, lockersystemId: string, maxRentingsPerUser?: number | null, maxRentingsPerUserEnabled: boolean, borrowingRightsUserGroups: Array<{ __typename?: 'UserGroup', id: string, name: string }> } | null } };

export type DeleteItemGroupMutationVariables = Types.Exact<{
  input: Types.DeleteItemGroup;
}>;


export type DeleteItemGroupMutation = { __typename?: 'Mutation', deleteItemGroup: { __typename?: 'DeleteItemGroupResponse', itemGroupId?: string | null } };

export type UpdateItemGroupMutationVariables = Types.Exact<{
  input: Types.UpdateItemGroup;
}>;


export type UpdateItemGroupMutation = { __typename?: 'Mutation', updateItemGroup: { __typename?: 'UpdateItemGroupResponse', itemGroup?: { __typename?: 'ItemGroup', id: string, name: string, lockersystemId: string, maxRentingsPerUser?: number | null, maxRentingsPerUserEnabled: boolean, borrowingRightsUserGroups: Array<{ __typename?: 'UserGroup', id: string, name: string }> } | null } };

export type FeatureParametersQueryVariables = Types.Exact<{
  lockersystemId: Types.Scalars['ID'];
}>;


export type FeatureParametersQuery = { __typename?: 'Query', lockersystem?: { __typename?: 'Lockersystem', id: string, rentingNonRegistered?: boolean | null, deliveryNonRegistered?: boolean | null, showWhoBorrows?: boolean | null, deliveryWithIdentityCode?: boolean | null } | null };

export type MyLockersystemPermissionQueryVariables = Types.Exact<{
  lockersystemId: Types.Scalars['ID'];
}>;


export type MyLockersystemPermissionQuery = { __typename?: 'Query', myLockersystemPermission?: { __typename?: 'LockersystemUserPermission', isAdmin?: boolean | null, accessDenied?: boolean | null } | null };


export const SearchItemGroupsDocument = gql`
    query searchItemGroups($opt: SearchItemGroupsOptions) {
  itemGroups(opt: $opt) {
    itemGroups {
      id
      name
      lockersystemId
      borrowingRightsUserGroups {
        id
        name
      }
      maxRentingsPerUser
      maxRentingsPerUserEnabled
    }
  }
}
    `;

/**
 * __useSearchItemGroupsQuery__
 *
 * To run a query within a React component, call `useSearchItemGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchItemGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchItemGroupsQuery({
 *   variables: {
 *      opt: // value for 'opt'
 *   },
 * });
 */
export function useSearchItemGroupsQuery(baseOptions?: Apollo.QueryHookOptions<SearchItemGroupsQuery, SearchItemGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchItemGroupsQuery, SearchItemGroupsQueryVariables>(SearchItemGroupsDocument, options);
      }
export function useSearchItemGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchItemGroupsQuery, SearchItemGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchItemGroupsQuery, SearchItemGroupsQueryVariables>(SearchItemGroupsDocument, options);
        }
export type SearchItemGroupsQueryHookResult = ReturnType<typeof useSearchItemGroupsQuery>;
export type SearchItemGroupsLazyQueryHookResult = ReturnType<typeof useSearchItemGroupsLazyQuery>;
export type SearchItemGroupsQueryResult = Apollo.QueryResult<SearchItemGroupsQuery, SearchItemGroupsQueryVariables>;
export const ItemGroupDocument = gql`
    query itemGroup($itemGroupId: ID!) {
  itemGroup(itemGroupId: $itemGroupId) {
    id
    name
    lockersystemId
    borrowingRightsUserGroups {
      id
      name
    }
    maxRentingsPerUser
    maxRentingsPerUserEnabled
  }
}
    `;

/**
 * __useItemGroupQuery__
 *
 * To run a query within a React component, call `useItemGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemGroupQuery({
 *   variables: {
 *      itemGroupId: // value for 'itemGroupId'
 *   },
 * });
 */
export function useItemGroupQuery(baseOptions: Apollo.QueryHookOptions<ItemGroupQuery, ItemGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemGroupQuery, ItemGroupQueryVariables>(ItemGroupDocument, options);
      }
export function useItemGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemGroupQuery, ItemGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemGroupQuery, ItemGroupQueryVariables>(ItemGroupDocument, options);
        }
export type ItemGroupQueryHookResult = ReturnType<typeof useItemGroupQuery>;
export type ItemGroupLazyQueryHookResult = ReturnType<typeof useItemGroupLazyQuery>;
export type ItemGroupQueryResult = Apollo.QueryResult<ItemGroupQuery, ItemGroupQueryVariables>;
export const CreateItemGroupDocument = gql`
    mutation createItemGroup($input: CreateItemGroup!) {
  createItemGroup(input: $input) {
    itemGroup {
      id
      name
      lockersystemId
      borrowingRightsUserGroups {
        id
        name
      }
      maxRentingsPerUser
      maxRentingsPerUserEnabled
    }
  }
}
    `;
export type CreateItemGroupMutationFn = Apollo.MutationFunction<CreateItemGroupMutation, CreateItemGroupMutationVariables>;

/**
 * __useCreateItemGroupMutation__
 *
 * To run a mutation, you first call `useCreateItemGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateItemGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createItemGroupMutation, { data, loading, error }] = useCreateItemGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateItemGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateItemGroupMutation, CreateItemGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateItemGroupMutation, CreateItemGroupMutationVariables>(CreateItemGroupDocument, options);
      }
export type CreateItemGroupMutationHookResult = ReturnType<typeof useCreateItemGroupMutation>;
export type CreateItemGroupMutationResult = Apollo.MutationResult<CreateItemGroupMutation>;
export type CreateItemGroupMutationOptions = Apollo.BaseMutationOptions<CreateItemGroupMutation, CreateItemGroupMutationVariables>;
export const DeleteItemGroupDocument = gql`
    mutation deleteItemGroup($input: DeleteItemGroup!) {
  deleteItemGroup(input: $input) {
    itemGroupId
  }
}
    `;
export type DeleteItemGroupMutationFn = Apollo.MutationFunction<DeleteItemGroupMutation, DeleteItemGroupMutationVariables>;

/**
 * __useDeleteItemGroupMutation__
 *
 * To run a mutation, you first call `useDeleteItemGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteItemGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteItemGroupMutation, { data, loading, error }] = useDeleteItemGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteItemGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteItemGroupMutation, DeleteItemGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteItemGroupMutation, DeleteItemGroupMutationVariables>(DeleteItemGroupDocument, options);
      }
export type DeleteItemGroupMutationHookResult = ReturnType<typeof useDeleteItemGroupMutation>;
export type DeleteItemGroupMutationResult = Apollo.MutationResult<DeleteItemGroupMutation>;
export type DeleteItemGroupMutationOptions = Apollo.BaseMutationOptions<DeleteItemGroupMutation, DeleteItemGroupMutationVariables>;
export const UpdateItemGroupDocument = gql`
    mutation updateItemGroup($input: UpdateItemGroup!) {
  updateItemGroup(input: $input) {
    itemGroup {
      id
      name
      lockersystemId
      borrowingRightsUserGroups {
        id
        name
      }
      maxRentingsPerUser
      maxRentingsPerUserEnabled
    }
  }
}
    `;
export type UpdateItemGroupMutationFn = Apollo.MutationFunction<UpdateItemGroupMutation, UpdateItemGroupMutationVariables>;

/**
 * __useUpdateItemGroupMutation__
 *
 * To run a mutation, you first call `useUpdateItemGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemGroupMutation, { data, loading, error }] = useUpdateItemGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateItemGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItemGroupMutation, UpdateItemGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItemGroupMutation, UpdateItemGroupMutationVariables>(UpdateItemGroupDocument, options);
      }
export type UpdateItemGroupMutationHookResult = ReturnType<typeof useUpdateItemGroupMutation>;
export type UpdateItemGroupMutationResult = Apollo.MutationResult<UpdateItemGroupMutation>;
export type UpdateItemGroupMutationOptions = Apollo.BaseMutationOptions<UpdateItemGroupMutation, UpdateItemGroupMutationVariables>;
export const FeatureParametersDocument = gql`
    query featureParameters($lockersystemId: ID!) {
  lockersystem(lockersystemId: $lockersystemId) {
    id
    rentingNonRegistered
    deliveryNonRegistered
    showWhoBorrows
    deliveryWithIdentityCode
  }
}
    `;

/**
 * __useFeatureParametersQuery__
 *
 * To run a query within a React component, call `useFeatureParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureParametersQuery({
 *   variables: {
 *      lockersystemId: // value for 'lockersystemId'
 *   },
 * });
 */
export function useFeatureParametersQuery(baseOptions: Apollo.QueryHookOptions<FeatureParametersQuery, FeatureParametersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureParametersQuery, FeatureParametersQueryVariables>(FeatureParametersDocument, options);
      }
export function useFeatureParametersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureParametersQuery, FeatureParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureParametersQuery, FeatureParametersQueryVariables>(FeatureParametersDocument, options);
        }
export type FeatureParametersQueryHookResult = ReturnType<typeof useFeatureParametersQuery>;
export type FeatureParametersLazyQueryHookResult = ReturnType<typeof useFeatureParametersLazyQuery>;
export type FeatureParametersQueryResult = Apollo.QueryResult<FeatureParametersQuery, FeatureParametersQueryVariables>;
export const MyLockersystemPermissionDocument = gql`
    query myLockersystemPermission($lockersystemId: ID!) {
  myLockersystemPermission(lockersystemId: $lockersystemId) {
    isAdmin
    accessDenied
  }
}
    `;

/**
 * __useMyLockersystemPermissionQuery__
 *
 * To run a query within a React component, call `useMyLockersystemPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLockersystemPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLockersystemPermissionQuery({
 *   variables: {
 *      lockersystemId: // value for 'lockersystemId'
 *   },
 * });
 */
export function useMyLockersystemPermissionQuery(baseOptions: Apollo.QueryHookOptions<MyLockersystemPermissionQuery, MyLockersystemPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLockersystemPermissionQuery, MyLockersystemPermissionQueryVariables>(MyLockersystemPermissionDocument, options);
      }
export function useMyLockersystemPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLockersystemPermissionQuery, MyLockersystemPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLockersystemPermissionQuery, MyLockersystemPermissionQueryVariables>(MyLockersystemPermissionDocument, options);
        }
export type MyLockersystemPermissionQueryHookResult = ReturnType<typeof useMyLockersystemPermissionQuery>;
export type MyLockersystemPermissionLazyQueryHookResult = ReturnType<typeof useMyLockersystemPermissionLazyQuery>;
export type MyLockersystemPermissionQueryResult = Apollo.QueryResult<MyLockersystemPermissionQuery, MyLockersystemPermissionQueryVariables>;